export const HistoryData = [
    {
        year: 2025,
        months: {
            january: {
                title: "january",
                img: `${process.env.PUBLIC_URL}/images/history/2025_01.jpg`,
                daily: [
                { day: 6, description: "2025시즌 선수단 연봉 재계약 완료" },
                { day: 23, description: "2025년 1차 스프링캠프 실시" },
                { day: 30, description: "선발과 불펜의 핵심 김광현, 노경은 첫 불펜 피칭 실시, 박정권 퓨처스 감독 선임" },
                { day: 31, description: "새 외국인 투수 미치 화이트 첫 불펜 피칭 실시" },
                ],
            },
            february: {
                title: "february",
                img: `${process.env.PUBLIC_URL}/images/history/2025_02.jpg`,
                daily: [
                { day: 10, description: "퓨처스팀, 日 가고시마에서 스프링캠프 실시" },
                { day: 16, description: "플로리다 스프링캠프 첫 자체 홍백전 실시" },
                { day: 18, description: "플로리다 스프링캠프 마지막 홍백전 실시" },
                { day: 21, description: "미국 플로리다 1차 스프링캠프 성료" },
                { day: 23, description: "日 오키나와 2차 스프링캠프 실시" },
                { day: 25, description: "2025 멤버십 회원 모집" },
                { day: 27, description: "2025 오키나와 스프링캠프 팬투어 실시" },
                ],
            },
            march: {
                title: "march",
                img: `${process.env.PUBLIC_URL}/images/history/2025_03.jpg`,
                daily: [
                { day: 5, description: "日 오키나와 2차 스프링캠프 마무리" },
                { day: 7, description: "2025 시즌티켓 판매" },
                { day: 9, description: "퓨처스팀, 日 가고시마 2차 스프링캠프 성료" },
                { day: 22, description: "요기요와 F&B 파트너십 체결, 구장 내 ‘포장 서비스’ 입점..." },
                ],
            },
            april: {
                title: "april",
                img: `${process.env.PUBLIC_URL}/images/history/2025_04.jpg`,
                daily: [
                { day: 9, description: "LG와의 주말 3연전에 ‘스타벅스 데이’ 실시" },
                { day: 14, description: "모토로라솔루션 데이 이벤트 진행" },
                { day: 16, description: "박종훈, 인하대병원과 7년째 ‘행복 드림 캠페인’ 동행" },
                { day: 20, description: "시즌 세 번째 만원 관중 달성 \n 에레디아 부상 대체 외국인선수로 라이언 맥브룸 영입"},
                { day: 21, description : "소아암 환우 돕는 ‘제로 그라운드 x 테디베어 포키즈’ 캠페인 진행"},
                { day: 24, description : "구단 공식 트레이딩 카드 출시"},
                { day: 27, description : "삼성과 주중 3연전 맞아 승리 기원 시구 진행"},
                { day: 28, description : "라인프렌즈 미니니(minini)와 함께 콜라보레이션 상품 출시"},
                ],
            },
            may: {
                title: "may",
                img: `${process.env.PUBLIC_URL}/images/history/2025_05.jpg`,
                daily: [
                { day: 1, description: "신세계푸드와 함께 ‘NBB 데이’ 실시" },
                { day: 2, description: "산리오의 인기 캐릭터 ‘포차코’와 함께 콜라보레이션 MD 출시" },
                { day: 4, description: "“청라돔을 빛낼 별들을 키운다” 2군 통합 육성 인프라 전면 리뉴얼" },
                { day: 10, description: "시즌 네 번째 만원 관중 달성"},
                { day: 11, description : "시즌 다섯 번째 만원 관중 달성"},
                { day: 15, description : "인기 이모티콘 캐릭터 ‘깜자’와 콜라보레이션 상품 출시"},
                { day: 18, description : "김광현, 한국 야구의 미래를 위한 ‘KK 드림업 프로젝트’ 2년 연속 진행"},
                { day: 20, description : "삼진제약과 ‘하루엔진 이뮨 부스터샷 데이’ 이벤트 진행 \n 2025시즌 ‘이마트 몰리스와 함께하는 도그데이’ 개최"},
                { day: 21, description : "국민건강보험공단과 함께 ‘하늘반창고 키즈 데이’ 진행"},
                { day: 24, description : "시즌 일곱 번째 만원 관중 달성 \n  24일(토) LG전에 ‘찐팬’ 배우 한지은 승리 기원 시구 진행"},
                { day: 25, description : "25일(일) LG전 걸그룹 ‘키키(KiiKii)’ 멤버 수이 승리 기원 시구 진행 \n NC와의 홈경기에 승리 기원 시구 진행 \n 시즌 여덟 번째 만원 관중 달성"},
                { day: 28, description : "한국산업인력공단 인천지사와 함께 ‘HRDK DNA 데이’ 진행"},
                ],
            },
            june: {
                title: "june",
                img: `${process.env.PUBLIC_URL}/images/history/2025_06.jpg`,
                daily: [
                { day: 3, description: "6월 3일(화) 삼성전 ‘플러스 데이’ 진행\n  구단 단일 시즌 최다 매진 타이 달성\n  최정, 국제바로병원과 함께 14년째 ‘사랑의 홈런 캠페인’ 동행" },
                { day: 4, description: "퓨처스팀 대상 ‘MLB 레전드 멘토링 데이’ 개최" },
                { day: 5, description: "빵야! SSG랜더스의 하루’ 카카오톡 이모티콘 출시" },
                { day: 6, description: "14일(토) 추신수 구단주 보좌역 은퇴식 개최"},
                { day: 7, description : "대한항공 점보스와 인천 소외계층 아동 위해 공동 기부금 전달\n 외야수 김성욱 트레이드 영입"},
                { day: 11, description : "NPB 웨스턴리그 출신 장현진 영입…유틸리티 야수진 보강"},
                { day: 13, description : "투수 김광현과 다년 계약 체결"},
                { day: 14, description : "구단 단일 시즌 최다 매진 기록 달성"},
                { day: 17, description : "28일(토) 김강민 KBO 전력강화위원 은퇴식 개최"},
                { day: 21, description : "시즌 열한 번째 만원 관중 달성"},
                { day: 22, description : "시즌 열두 번째 만원 관중 달성"},
                { day: 17, description : "시즌 열세 번째 만원 관중 달성"},
                { day:29, description:  "시즌 열 다섯 번째 매진 기록 달성"}
                ],
            },
            july: {
                title: "july",
                img: '',
                daily:[
                    { day: '', description: ""},
                ],
            },
            august: {
                title: "august",
                img: '',
                daily:[
                    { day: '', description: ""},
                ],
            },
            september: {
                title: "september",
                img: '',
                daily:[
                    { day: '', description: ""},
                ],
            },
            october: {
                title: "october",
                img: '',
                daily:[
                    { day: '', description: ""},
                ],
            },
            november: {
                title: "november",
                img: '',
                daily:[
                    { day: '', description: ""},
                ],
            },
        },
    },
    {
        year: 2024,
        months: {
            january: {
                title: "january",
                img: `${process.env.PUBLIC_URL}/images/history/2024_01.jpg`,
                daily: [
                    { day: 6, description: '24시즌 선수단 연봉 재계약 완료'},
                    { day: 11, description: '이흥련 선수, 구단 원정 전력분석원으로 새출발'},
                    { day: 12, description: '포수 이지영 트레이드 영입'},
                    { day: 16, description : "FA 김민식과 2년 총액 5억원에 계약"},
                    { day: 17, description : "다이나핏과 선수단 용품 후원 재계약으로 10년 동행"},
                    { day: 19, description : "내야수 김성현과 다년 계약 체결"},
                    { day: 21, description : "신규 BI 공개 및 팬 페스티벌 개최"},
                    { day: 25, description : "2024 프런트 신년 워크숍 실시"},
                    { day: 31, description : "2024 대만 스프링캠프 팬투어 참가자 모집"},
                ],
            },
            february: {
                title: "february",
                img: `${process.env.PUBLIC_URL}/images/history/2024_02.jpg`,
                daily: [
                    { day: 5, description: '선수단 금연 교육 실시'},
                    { day: 14, description: '2024 시즌티켓 판매'},
                    { day: 15, description: '퓨처스팀, 2024 대만 스프링캠프 실시'},
                ],
            },
            march: {
                title: "march",
                img: `${process.env.PUBLIC_URL}/images/history/2024_03.jpg`,
                daily: [
                    { day: 5, description: '2024 멤버십 회원 모집'},
                    { day: 7, description: '2024 대만 자이 2차 스프링캠프 종료'},
                    { day: 10, description: '퓨처스팀 2024 대만 자이 스프링캠프 종료'},
                ],
            },
            april: {
                title: "april",
                img: `${process.env.PUBLIC_URL}/images/history/2024_04.jpg`,
                daily: [
                    { day: 4, description: '플러스정형외과의원과 ‘24시즌 선수단 지정병원’ 협약 체결'},
                    { day: 10, description: '24시즌 ‘이마트 몰리스와 함께하는 도그데이’ 개최 \n박종훈, 인하대병원과 6년째 ‘행복 드림 캠페인’ 실시'},
                    { day: 11, description: '최정, 국제바로병원과 함께 13년째 ‘사랑의 홈런 캠페인’ 동행'},
                    { day: 19,description : "농심과 함께 ‘출시 40주년 기념 짜파게티 데이’ 진행"},
                    { day: 26,description : "KT 주말 3연전을 맞아 ‘스타벅스 데이’ 실시"},
                    { day: 27, description : "외국인 투수 드류 앤더슨 영입"}
                ],
            },
            may: {
                title: "may",
                img: `${process.env.PUBLIC_URL}/images/history/2024_05.jpg`,
                daily: [
                    { day: 4, description: "신세계푸드와 함께 ‘2024 NBB DAY’ 실시"},
                    { day: 10, description: "도드람한돈 4월 MVP에 조병현, 최정 선정"},
                    { day: 11, description: "KBS Kids와 함께 어린이날 맞이 스페셜 기프트 증정"},
                    { day: 19, description: "세방전지와 함께 ‘로케트 배터리 데이’ 실시 \n  한유섬, 부평우리치과와 8년 연속 '희망 홈런 캠페인' 진행"},
                    { day: 26, description: "엘리아스 부상 대체 외국인선수로 시라카와 케이쇼 영입"},
                    { day: 27, description: " 최정 최다 홈런 신기록과 함께하는 ‘SSG.COM DAY’ 실시 \n 인천SSG랜더스필드 ‘투명PET병 수거 로봇’ 도입 \n‘LINE FRIENDS’와 함께 협업 상품 출시"},
                ],
            },
            june: {
                title: "june",
                img: `${process.env.PUBLIC_URL}/images/history/2024_06.jpg`,
                daily: [
                    { day: 7, description: "다비치안경과 함께하는 ‘희망 EYE 캠페인’ 실시"},
                    { day: 8, description: "포스코인터내셔널과 함께하는 ‘그린 투모로우 데이’ 진행"},
                    { day: 10, description: "인천 프로스포츠 콜라보 데이’ 진행 \n 김광현, 야구 꿈나무를 위한 ‘KK 드림업 프로젝트’ 진행"},
                    { day: 13, description: "이마트와 함께 ‘이마트 패밀리 데이’ 실시 \n스포츠안전재단과 야구장 안전문화 조성 업무 협약 체결"},
                    { day: 25, description: "‘라인프렌즈(LINE FRIENDS)’ 2차 협업 상품 출시 및 오프라인 이벤트 실시"},
                ],
            },
            july: {
                title: "july",
                img: `${process.env.PUBLIC_URL}/images/history/2024_07.jpg`,
                daily: [
                    { day: 2, description: "부상 대체 외국인선수 시라카와 케이쇼와 계약 종료"},
                    { day: 4, description: "‘다회용기’ 도입해 친환경 관람 문화 조성 \n TS한국교통안전공단과 음주운전 근절 캠페인 진행"},
                    { day: 7, description: "안산 마인드 치과와 4년째 ‘덴탈케어 파트너십’ 협약 체결"},
                    { day: 12, description: "도드람한돈 6월 MVP에 노경은, 박지환 선정"},
                    { day: 17, description: "SSG랜더스X미첼앤네스 한정판 콜라보레이션 상품 출시"},
                    { day: 18, description: "주말 키움 3연전에 ‘랜디 데이’ 진행"},
                    { day: 22, description: "Fighters Sports & Entertainment와 상호 업무 협약(MOU) 체결"},
                    { day: 30, description: "여름철 무더위를 날릴 ‘랜필 썸머 페쓱티벌’ 실시 \n두산과의 주말 3연전에 승리 기원 시구 진행"},
                ],
            },
            august: {
                title: "august",
                img: `${process.env.PUBLIC_URL}/images/history/2024_08.jpg`,
                daily: [
                    { day: 10, description: "도드람한돈 7월 MVP에 앤더슨, 에레디아 선정"},
                    { day: 17, description: "시즌 다섯 번째 만원 관중 달성 \n 디즈니코리아와 함께 ‘더 존 브랜드 데이’ 진행"},
                    { day: 18, description: "18일 홈경기에 앞서 승리 기원 행사 진행"},
                    { day: 31, description: "삼진제약과 함께 ‘이뮨부스터샷 데이’ 진행 \n알파 인더스트리와 함께 콜라보레이션 상품 출시"},
                ],
            },
            september: {
                title: "september",
                img: `${process.env.PUBLIC_URL}/images/history/2024_09.jpg`,
                daily: [
                    { day: 2, description: "인천 야구 역사 최초 2년 연속 100만 관중 달성 \n 도드람한돈 8월 MVP에 앤더슨, 최정 선정"},
                    { day: 4, description: "‘인천광역시 치매극복의 날’ 진행 \n 포수 최대어 강릉고 이율예 1R 지명"},
                    { day: 15, description: "국민건강보험공단과 함께 ‘하늘반창고 키즈 데이’ 진행"},
                    { day: 18, description: "인천시와 함께 ‘인천 랜딩 데이’ 진행 \n 시즌 여섯 번째 만원 관중 달성"},
                    { day: 21, description: "시즌 일곱 번째 만원 관중 달성"},
                    { day: 23, description: "인천 연고팀 역대 최다 관중 신기록 달성"},
                    { day: 24, description: "단일 시즌 최다 매진 타이 달성 \n 시즌 최종전 맞아 최다 관중 신기록 감사 이벤트 진행"},
                ],
            },
            october: {
                title: "october",
                img: `${process.env.PUBLIC_URL}/images/history/2024_10.jpg`,
                daily: [
                    { day: 1, description: "방출 선수 명단 발표"},
                    { day: 3, description: "2025 신인 선수 10명 전원과 계약 완료"},
                    { day: 4, description: "김강민 은퇴식 개최 결정 \n 세리자와, 이영욱, 이명기 코치 신규 영입"},
                    { day: 10, description: "2025년 신인 선수 교육 및 입단식 실시"},
                    { day: 15, description: "경헌호 투수코치 영입"},
                    { day: 21, description: "가고시마 유망주 캠프 실시"},
                    { day: 28, description: "KT위즈와 1대1 트레이드 단행"},
                ],
            },
            november: {
                title: "november",
                img: `${process.env.PUBLIC_URL}/images/history/2024_11.jpg`,
                daily: [
                    { day: 6, description: "KBO리그 최다 홈런 최정과 FA계약 체결"},
                    { day: 16, description: "외국인 투수 미치 화이트 영입 \n 추신수, 스타벅스와 ‘SHARE WITH THE CHOO’ 진행"},
                    { day: 17, description: "드류 앤더슨과 재계약"},
                    { day: 21, description: "홀드왕 노경은과 FA계약 체결"},
                    { day: 27, description: "타격왕 에레디아와 재계약"},
                    { day: 28, description: "가고시마 유망주 캠프 성료 \n 나경민 코치 신규 영입"},
                    { day: 30, description: "팬 감사 자선 식당&카페 ‘캐처테이블’ 진행"},
                ],
            },
        },
    },
    {
        year: 2023,
        months: {
            january: {
                title: "january",
                img: `${process.env.PUBLIC_URL}/images/history/2023_01.jpg`,
                daily: [
                    { day: 6, description: '24시즌 선수단 연봉 재계약 완료'},
                    { day: 11, description: '이흥련 선수, 구단 원정 전력분석원으로 새출발'},
                    { day: 12, description: '포수 이지영 트레이드 영입'},
                ],
            },
            february: {
                title: "february",
                img: `${process.env.PUBLIC_URL}/images/history/2023_02.jpg`,
                daily: [
                    { day: 5, description: '선수단 금연 교육 실시'},
                    { day: 14, description: '2024 시즌티켓 판매'},
                    { day: 15, description: '퓨처스팀, 2024 대만 스프링캠프 실시'},
                ],
            },
            march: {
                title: "march",
                img: `${process.env.PUBLIC_URL}/images/history/2023_03.jpg`,
                daily: [
                    { day: 5, description: '2024 멤버십 회원 모집'},
                    { day: 7, description: '2024 대만 자이 2차 스프링캠프 종료'},
                    { day: 10, description: '퓨처스팀 2024 대만 자이 스프링캠프 종료'},
                ],
            },
            april: {
                title: "april",
                img: `${process.env.PUBLIC_URL}/images/history/2023_04.jpg`,
                daily: [
                    { day: 1, description: "홈 개막 2연전 챔피언 오프닝 시리즈 이벤트 진행 \n 2023시즌 개막전 만원 관중 달성"},
                    { day: 2, description: "인천 연고 첫 개막 2연전 만원 관중 기록"},
                    { day: 4, description: "플러스 정형외과와 선수단 공식지정의료기관 업무협약 체결"},
                    { day: 14, description: "22시즌 한국시리즈 우승 기념 NFT 굿즈 출시 \n 미추홀구와 함께 연고지역 상생 위한 공동 마케팅 추진"},
                    { day: 26, description: "스타벅스 데이 기념 유니폼 2종 출시"},
                    { day: 28, description: "두산 주말 3연전 ‘스타벅스 데이’ 개최 \n 이마트24와 함께 3년째 ‘삼진 기부 캠페인’ 동행"},
                    { day: 30, description: "SSG랜더스 김광현 150승 기념 이벤트 통해 100명에게 기념 반지, 유니폼 선물"},
               ],
            },
            may: {
                title: "may",
                img: `${process.env.PUBLIC_URL}/images/history/2023_05.jpg`,
                daily: [
                    { day: 2, description: "키즈 크리에이터 초청해 ‘샌박 프렌즈 데이’ 진행"},
                    { day: 3, description: "SSG랜더스 최정, 국제바로병원과 함께 12년째 ‘사랑의 홈런 캠페인’ 진행"},
                    { day: 4, description: "외국인 투수 로에니스 엘리아스 영입"},
                    { day: 12, description: "도드람한돈 4월 MVP에 서진용, 최지훈 선정"},
                    { day: 13, description: "시즌 세 번째 만원 관중 달성"},
                    { day: 23, description: "SSG랜더스 한유섬, 부평우리치과와 7년 연속 '희망 홈런 캠페인' 진행 \n 가천대 길병원과 선수단 공식협력병원 업무협약 체결"},
                    { day: 24, description: "‘LH와 함께하는 스쿨데이’ 개최"},
                    { day: 25, description: "두산베어스와 1대1 트레이드 단행"},
                ],
            },
            june: {
                title: "june",
                img: `${process.env.PUBLIC_URL}/images/history/2023_06.jpg`,
                daily: [
                    { day: 2, description: "신세계푸드와 함께 ‘2023 NBB DAY’ 개최 \n 프랫 안경원과 함께하는 ‘희망 EYE 캠페인’ 진행"},
                    { day: 5, description: "‘함께 으쓱 프로젝트’로 구단의 스포츠 ESG 통합 운영"},
                    { day: 13, description: "매일헬스뉴트리션 셀렉스와 공식 물품 후원 협약 체결"},
                    { day: 14, description: "도드람한돈 5월 MVP에 노경은, 최정 선정 \n ‘유한킴벌리 데이’ 실시"},
                    { day: 15, description: "대한항공 점보스와 인천 소외계층 아동 위해 공동 기부금 전달"},
                    { day: 16, description: "올바른 종이팩 분리배출법 알리는 친환경 ‘캡틴쓱 데이’ 진행 \n 주말 롯데 3연전 ‘랜더스 유니버스 시리즈’ 개최"},
                    { day: 17, description: "인천광역시•인천경찰청과 함께 ‘피싱예방 데이’ 진행 \n ‘SSG.COM DAY’ 기념 유니폼 및 모자 출시 \n  시즌 네 번째 만원 관중 달성"},
                    { day: 19, description: "2023시즌 ‘이마트 몰리스와 함께하는 도그데이’ 진행"},
                    { day: 23, description: "SSG닷컴과 함께 ‘SSG.COM DAY’ 진행"},
                    { day: 28, description: "‘헤드앤숄더와 함께하는 쓱싹데이’ 실시"},
                    { day: 29, description: "CJ제일제당과 함께 ‘고메 소바바치킨 브랜드 데이’ 실시 \n  SSG랜더스 추신수, ‘행복 랜딩’ 캠페인으로 3년째 기부 프로그램 추진 \n SSG랜더스 이재원, 인하대병원과 함께 ‘23시즌 희망 드림 캠페인’ 협약 체결"},
                ],
            },
            july: {
                title: "july",
                img: `${process.env.PUBLIC_URL}/images/history/2023_07.jpg`,
                daily: [
                    { day: 4, description: "‘헤드앤숄더와 함께하는 쓱싹데이’ 실시"},
                    { day: 6, description: "SSG랜더스 추신수, ‘추신水’ 생수로 유소년 야구 꿈나무 지원 프로젝트에 참여"},
                    { day: 11, description: "인구보건복지협회 인천지회와 함께 ‘인구의 날’ 행사 진행"},
                    { day: 13, description: "2023시즌 두 번째 ‘스쿨데이’ 진행"},
                    { day: 14, description: "도드람한돈 6월 MVP에 문승원, 최정 선정"},
                    { day: 29, description: "농심과 함께하는 ‘짜파게티 데이’ 실시"},
                ],
            },
            august: {
                title: "august",
                img: `${process.env.PUBLIC_URL}/images/history/2023_08.jpg`,
                daily: [
                    { day: 8, description: "2022시즌 ‘와이어 투 와이어’ 통합우승 기념 포토북 ‘PERFECT LANDING’ 발간 \n 구관모식초와 후원물품 전달식 진행 \n 인천지역 고교야구부에 야구발전 후원물품 기부"},
                    { day: 9, description: "바이오스틸과 스포츠음료 후원 협약 체결"},
                    { day: 11, description: "더핑크퐁컴퍼니와 함께하는 ‘아기상어 데이’ 개최 \n 도드람한돈 7월 MVP에 서진용, 김성현 선정"},
                    { day: 18, description: "이마트 30주년 기념 ‘이마트 데이’ 실시"},
                    { day: 19, description: "시즌 다섯 번째 만원 관중 달성"},
                    { day: 25, description: "SSG랜더스 박종훈, 인하대병원과 5년째 ‘행복 드림 캠페인’ 실시"},
                    { day: 30, description: "안산 마인드 치과와 3년째 ‘덴탈케어 파트너’ 동행"},
                ],
            },
            september: {
                title: "september",
                img: `${process.env.PUBLIC_URL}/images/history/2023_09.jpg`,
                daily: [
                    { day: 2, description: "시즌 여섯 번째 만원 관중 달성"},
                    { day: 3, description: "코칭스태프 보직 변경 단행 \n 시즌 일곱 번째 만원 관중 달성"},
                    { day: 11, description: "도드람한돈 8월 MVP에 맥카티, 추신수 선정"},
                    { day: 12, description: "야수 최대어 세광고 내야수 박지환 1라운드 지명"},
                    { day: 14, description: "신규 어센틱 구단 점퍼 출시"},
                    { day: 20, description: "인천광역치매센터와 함께 ‘치매극복의 날’ 실시"},
                    { day: 21, description: "주말 롯데 3연전에 ‘랜디 데이’ 실시"},
                    { day: 22, description: "SSG랜더스 김태훈 선수 은퇴"},
                    { day: 28, description: "도드람한돈과 ‘메리 추석 데이’ 실시"},
                ],
            },
            october: {
                title: "october",
                img: `${process.env.PUBLIC_URL}/images/history/2023_10.jpg`,
                daily: [
                    { day: 4, description: "‘구도 인천’의 야구 열기로 프로야구 흥행 몰이 견인 \n 창단 첫 100만 관중 달성 기념 ‘위크 이벤트’ 개최"},
                    { day: 6, description: "오버더피치와 함께 ‘슈퍼SSG랜더스 데이’ 실시"},
                    { day: 8, description: "2024 신인 선수 11명 전원 계약 완료"},
                    { day: 12, description: "인천경제자유구역청 ∙ 인천테크노파크와 스마트 구단 구축을 위한 업무협약 체결"},
                    { day: 18, description: "도드람한돈 9월 MVP에 김광현, 한유섬 선정\n17일(화) 시즌 최종전에 김태훈 은퇴식 실시"},
                    { day: 20, description: "2023 KBO 준플레이오프 승리 기원 시구 진행"},
                    { day: 22, description: "2024년 신인 선수 교육 및 입단식 실시"},
                    { day: 29, description: "김원형 감독과 계약 해지"},
                ],
            },
        },
    }    
];